import React, { useEffect, useRef, useState } from 'react';
import './collectionSection.scss';
import { collectionOptions } from "../../../../components/utils/collectionData";
import ModalCardItem from "./components/ModalCardItem";
import {useTranslation} from "react-i18next";

const CollectionSection = () => {
	const { t } = useTranslation();
	const [hoveredIndex, setHoveredIndex] = useState<{ x: number | null; y: number | null }>({ x: null, y: null });
	const modalRef = useRef<HTMLDivElement | null>(null);
	// const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

	/*const handleOpenModal = (e: React.MouseEvent, index: number, idx: number) => {
		// if (hoveredIndex.x === null && hoveredIndex.y === null) {
			setHoveredIndex({ x: index, y: idx });
			setModalPosition({ top: e.clientY, left: e.clientX > (window.innerWidth - 340) ? e.clientX - 300 : e.clientX });
		// }
	}*/

	const handleOpenModal = (e: React.MouseEvent, index: number, idx: number) => {
		const targetElement = e.currentTarget.getBoundingClientRect();
		// const modalTop = targetElement.top + window.scrollY - 150;
		// const modalLeft = targetElement.left + window.scrollX - 50;

		setHoveredIndex({ x: index, y: idx });
		console.log("x: ", index, " y: ", idx);
		// setModalPosition({ top: modalTop, left: modalLeft });
	};


	const handleCloseModal = () => {
			setHoveredIndex({ x: null, y: null });
	}

	const handleMouseLeave = (e: any) => {
		if (!modalRef.current?.contains(e.relatedTarget)) {
			handleCloseModal();
		}
	};

	return (
		<div className="collection">
			<div className={`main__bg_animations_item c9`} />
			<div className="collection__content">
				<div className="collection__content_header">
					<h3>{t('fourCollection.title')}</h3>
				</div>
				<div className="collection__content_items">
					{collectionOptions && collectionOptions.length > 0 && collectionOptions.map((option: any, index: number) => (
						<div key={`${option.title} - ${index}`} className="collection__content_items_element">
							<div className="collection__content_items_element_info">
								<p>{t(`fourCollection.${option.title}`)}</p>
								<span>{t(`fourCollection.${option.description}`)}</span>
							</div>
							<div className="collection__content_items_element_colors">
								{option.colors && option.colors.length > 0 && option.colors.map((item: any, idx: number) => {
									const isHovered = hoveredIndex.x === index && hoveredIndex.y === idx;
									return (
										<div
											key={`${item.color} - ${idx}`}
											className="collection__content_items_element_colors_color"
											onMouseEnter={(event) => handleOpenModal(event, index, idx)}
											onMouseLeave={handleMouseLeave}
										>
											<div
												className="collection__modal_content"
												// ref={props.modalRef}
												// style={{ top: `${window.innerWidth < 768 ? '50%' : props.modalPosition.top - 815}px`, left: `${window.innerWidth < 768 ? '50%' : props.modalPosition.left - 85}px` }}
												// onMouseEnter={props.onMouseEnter}
											>
												{
													hoveredIndex.x === index && hoveredIndex.y === idx ? (
														<div className="collection__modal_content_data">
															{/*<img
																className={`elasticImage`}
																src={`${process.env.PUBLIC_URL}/assets/images/freeTies/${collectionOptions[hoveredIndex.x].title}Package.webp`}
																alt={`Large image`}
															/>*/}
															<img
																className={`elasticImage`}
																src={`${process.env.PUBLIC_URL}/assets/images/freeTies/${item.image}.webp`}
																alt={`Large image`}
															/>
															<div className="collection__modal_content_data_info">
																<p>{t(`fourCollection.${collectionOptions[hoveredIndex.x].title}`)}</p>
																<span>{t(`fourCollection.${collectionOptions[hoveredIndex.x].description}`)}</span>
															</div>
														</div>
													) : null
												}
											</div>
											<div
												className="collection__content_items_element_colors_color_item"
												style={{
													background: item.color,
													boxShadow: isHovered ? `0px 0px 10px 0px ${item.color}` : 'none',
													transition: 'box-shadow .3s ease-in-out',
												}}
												// onMouseEnter={(event) => handleOpenModal(event, index, idx)}
												// onMouseLeave={handleMouseLeave}
											/>
										</div>
									);
								})}
							</div>
							<div className="collection__content_items_element_button">
								<button className={`secondButton`}>
									<span>{t('buttons.seeCollection')}</span>
								</button>
							</div>
						</div>
					))}
				</div>
				{/*<ModalCardItem
					title={hoveredIndex.x !== null && hoveredIndex.y !== null ? t(`fourCollection.${collectionOptions[hoveredIndex.x].title}`) : ''}
					description={hoveredIndex.x !== null && hoveredIndex.y !== null ? t(`fourCollection.${collectionOptions[hoveredIndex.x].description}`) : ''}
					isOpen={hoveredIndex.x !== null && hoveredIndex.y !== null}
					onClose={handleCloseModal}
					modalRef={modalRef}
					modalPosition={modalPosition}
					onMouseEnter={() => setHoveredIndex(hoveredIndex)}
					onMouseLeave={handleCloseModal}
					image={hoveredIndex.x !== null && hoveredIndex.y !== null ? collectionOptions[hoveredIndex.x].title : ''}
				/>*/}
			</div>
		</div>
	);
};

export default CollectionSection;
